import type { ReceiptTemplate } from '../schema';

export const stockxTemplate: ReceiptTemplate = {
  id: 'stockx',
  name: 'StockX Receipt',
  brand: 'STOCKX',
  description: 'Sneaker and streetwear marketplace receipt template',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'sx-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/stockx.png',
        logoData: '',
        logoWidth: 140,
        logoHeight: 40,
        businessName: '',
        businessNameFontSize: 24,
        addressLines: [
          'Order Confirmation',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'sx-order',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'Order #: SX-847291-2026\nDate: January 4, 2026\nBuyer: mike.wazowski@email.com',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: false,
      },
    },
    {
      id: 'sx-verified',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: '✓ STOCKX VERIFIED',
        fontSize: 14,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: true,
      },
    },
    {
      id: 'sx-item',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'Jordan 1 Retro High OG\nChicago Lost and Found\nSize: US 10\nCondition: New\nSKU: DZ5485-612',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: false,
      },
    },
    {
      id: 'sx-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 45,
        labelAlignment: 'left',
        lines: [
          { id: 'sx-price', label: 'Item Price', value: '285.00', isBold: false, isLarge: false },
          { id: 'sx-shipping', label: 'Shipping', value: '13.95', isBold: false, isLarge: false },
          { id: 'sx-processing', label: 'Processing Fee', value: '17.10', isBold: false, isLarge: false },
          { id: 'sx-tax', label: 'Tax', value: '28.04', isBold: false, isLarge: false },
          { id: 'sx-total', label: 'Total', value: '344.09', isBold: true, isLarge: true },
        ],
        increaseTotalSize: true,
        totalSizeIncrease: 15,
        showDivider: true,
        dividerStyle: 'double',
      },
    },
    {
      id: 'sx-payment',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'Payment Method:\nVisa ending in 4144',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: false,
      },
    },
    {
      id: 'sx-shipping-info',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'Ship To:\nMike Wazowski\n1200 Dark Avenue\nMonsterville, CA 94608',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: false,
      },
    },
    {
      id: 'sx-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'Questions? Visit stockx.com/help\n\nAll sales are final.',
        fontSize: 10,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
};

